import React, { useEffect, useState, useRef } from "react";
import CreateDiscussion from "./CreateDiscussion";
import EditDiscussion from "./EditDiscussion";
import { API } from "../../services/api";
import profileimg from "../../assets/img/profile/profile-img.svg"
import Announcement from "../Posts/layouts/Announcement";
import About from "./About";
import ReportPost from "../Posts/popups/ReportPost";
import MakeFavourite from "../Posts/popups/MakeFavourite";
import ListDiscussions from "./ListDiscussions";
import Spinner from "../../commonComponents/Spinner";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import { useNavigate, useLocation } from 'react-router-dom';
import Confirmpopup from "../../commonComponents/Confirmpopup";
import { listOrganizationPosts } from "../../services/apiOragnizations";
import {
  deletePost
} from "../../services/apiPosts";


const Discussions = ({ organizationid }) => {
  const [EditStatus, setEditStatus] = useState(false);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const [loading, setLoading] = useState(true);
  const [Feeds, setFeeds] = useState([]);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showreport, setShowReport] = useState(false);
  const [reportId, setReportId] = useState(false);
  const [EditFeed, setEditFeed] = useState([]);
  const [isSucess, SetSucess] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");
  const [isConfirm, setConfirm] = useState(false);
  const [DeletPostid, setDeltePostId] = useState('');
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true); // pagination 
  const limit = 20; // Number of posts per fetch
  const location = useLocation();
  const lastPostRef = useRef(null);
  const [showfav, setFavourite] = useState(false);
  const [favouriteUserId, setFavouriteUserId] = useState(false);
  const [favouriteUserName, setFavouriteUserName] = useState("");
  const [favourites, setFavourites] = useState({});
  const [FavStatus, setFavStatus] = useState();
  const Organiationid = organizationid || userData._id;
  const OpenPopup = () => {
    setOpen(true);
  }
  const ClosePopup = () => {
    setOpen(false);
    setEditStatus(false);
  }

  useEffect(() => {
    let listpayload = {
      userid: userData._id,
      organizationid: Organiationid,
      offset: 0,
      limit: limit,
       source: "website"
    };
    localStorage.setItem("postpayload", JSON.stringify(listpayload));
    setOffset(0); // Reset offset
    setHasMore(true); // Reset hasMore
    setFeeds([]); // Clear existing feeds
    fetchAllDiscussions(listpayload);

  }, [location, Organiationid]);
  /* for pagination */
  const loadMoreFeeds = async (loadmorePayload) => {
    if (!hasMore || loading) return;
    setLoading(true);
    localStorage.setItem('postpayload', JSON.stringify(loadmorePayload));
    let listFeeds = await listOrganizationPosts(loadmorePayload);
    if (listFeeds.status === true) {
      if (listFeeds.posts.length === 0) {
        setHasMore(false); // No more posts to load
      } else {

        setFeeds((prevFeeds) => [...prevFeeds, ...listFeeds.posts]); // Append new posts
        setOffset(loadmorePayload.offset); // Update offset
        const initialLikedPosts = {};
        const intialFavourites = {};
        listFeeds.posts.forEach(post => {
          // Check if userlike array contains an object with isliked equal to 1
          if (post.userlike.length > 0 && post.userlike[0].isliked === 1) {
            initialLikedPosts[post._id] = true; // User liked the post
          } else {
            initialLikedPosts[post._id] = false; // User did not like the post
          }
          if (post.favouritemember.length > 0 && post.favouritemember[0].isfavourite === 1) {
            intialFavourites[post.user[0]._id] = true;
          } else {
            intialFavourites[post.user[0]._id] = false;
          }
        });
        
        setFavourites(intialFavourites);


      }


    }
    setLoading(false);

  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore) {
          const newOffset = offset + limit;
          const listpayload = JSON.parse(localStorage.getItem('postpayload'));
          listpayload.offset = newOffset;

          loadMoreFeeds(listpayload);
        }
      },
      { threshold: 0.1 } // Reduced threshold for earlier triggering
    );

    if (lastPostRef.current) {
      observer.observe(lastPostRef.current);
    }

    return () => {
      if (lastPostRef.current) {
        observer.unobserve(lastPostRef.current);
      }
    };
  }, [hasMore, offset, loading]); // Add loading to dependencies
  /* End pagination */

  const showReport = (postid) => {
    setShow(true);
    setShowReport(true);
    setReportId(postid)
  }
  const HideReport = () => {
    setShowReport(false);
  }
  const showFavourite = (userId, favname, arraylength) => {

    setFavourite(true);
    setFavouriteUserId(userId);
    setFavouriteUserName(favname);
    setFavStatus(favourites[userId] || false);

  }
  const HideFavourite = () => {
    setFavourite(false);
  }
  const toggleFavourite = (userId, newstatus) => {

    setFavourites((prevFavourites) => ({
      ...prevFavourites,
      [userId]: newstatus
    }));

  };

  const handleDelete = async (postid) => {
    setConfirm(false);
    let deletepayload = { postid: postid };
    let response = await deletePost(deletepayload);
    if (response.status === true) {
      SetSucess(true);
      SetResponseMessage("Post is Deleted!");
      setFeeds(prevFeeds => prevFeeds.filter(post => post._id !== postid));

    }

  }
  const DeletPost = async (postid) => {
    setConfirm(true);
    setDeltePostId(postid);
  };
  const handleEdit = (feed) => {
    setEditFeed(feed);
    setEditStatus(true);
    setOpen(true);
  }



  const fetchAllDiscussions = async (listpayload) => {
    setHasMore(true);
    setLoading(true);
    setFeeds([]); // Clear existing feeds when fetching new ones
    setOffset(0); // Reset offset
    let listFeeds = await listOrganizationPosts(listpayload);
    if (listFeeds.status === true) {
      //setFeeds(listFeeds?.posts || []);
      setFeeds((prevFeeds) => [...prevFeeds, ...listFeeds.posts]); // Append new posts
      setOffset(prevOffset => prevOffset + listFeeds.posts.length); // Update offset
      //const initialLikedPosts = {};
      const intialFavourites = {};
      listFeeds.posts.forEach(post => {
        
        if (post.favouritemember.length > 0 && post.favouritemember[0].isfavourite === 1) {
          if (post.user.length > 0)
            intialFavourites[post.user[0]._id] = true;
        } else {
          if (post.user.length > 0)
            intialFavourites[post.user[0]._id] = false;
        }

      });
      
      setFavourites(intialFavourites);

    }

    setLoading(false);

  }

  return (

    <div >
      <div className="community-features main ml-0">
        <div className="contents ml-0">
          {userData.userType === 'organization' && (
            <div className="profile_user">
              <div className="coverimage">
                <img src={
                  userData.coverImage?.url
                    ? API.uploadFilePath + userData.coverImage?.url
                    : profileimg
                } alt="test" className="cover_profile" />
                <div className="overlay"></div>
              </div>
              <div className="profile_main d-flex align-items-start">
                <div className="profile_avatar">
                  <img src={
                    userData?.profileImage?.url
                      ? API.uploadFilePath + userData.profileImage?.url
                      : profileimg
                  } alt="test" className="cover_profile" />
                </div>
                <div className="profile_details flex-fill">
                  <div className="avatarname_full d-flex-c">
                    <h3>{userData.firstName}</h3>

                  </div>

                </div>
              </div>
            </div>
          )}
          <div className="">
            



            <CreateDiscussion EditStatus={EditStatus} Organiationid={Organiationid} fetchAllDiscussions={fetchAllDiscussions} source="discussion" EditFeed={EditFeed}></CreateDiscussion>





            {Feeds.length === 0 && loading ? (
              <div className="d-flex justify-content-center my-5">
              </div>
            ) : (Feeds?.filter(post => post?.user?.[0]).map((post, index) => {
              return (
                <ListDiscussions post={post} index={index}
                  userData={userData} setShow={setShow}
                  DeletPost={DeletPost} showReport={showReport}
                  toggleFavourite={toggleFavourite} handleEdit={handleEdit}
                  favourites={favourites} showFavourite={showFavourite}>
                </ListDiscussions>
              )
            }
            ))}



          </div>
        </div>
        {userData.userType === 'organization' && (
          <About about={userData} />
        )}

      </div>
      <EditDiscussion openPop={open} closePop={ClosePopup} EditStatus={EditStatus} Organiationid={Organiationid} fetchAllDiscussions={fetchAllDiscussions} source="discussion" EditFeed={EditFeed}></EditDiscussion>
      <ReportPost showReport={showreport} HideReport={HideReport} reportId={reportId}></ReportPost>
      <MakeFavourite showFavourite={showfav} HideFavourite={HideFavourite} favouriteUserId={favouriteUserId} favouriteUserName={favouriteUserName} toggleFavourite={toggleFavourite} FavStatus={FavStatus}></MakeFavourite>
      {isSucess && (<ResponsePopup
        isSucess={isSucess}
        CancelPopup={() => {
          SetSucess(false);
        }}
        message={ResponseMessage}
      />)}
      {isConfirm && (<Confirmpopup
        isConfirm={isConfirm}
        DeletPostid={DeletPostid}
        handleDelete={handleDelete}
        type="discussion"
        CancelPopup={() => {
          setConfirm(false);
        }}

      />)}
      {loading && (
        <div className="d-flex justify-content-center my-3">
          <Spinner />
        </div>
      )}
    </div>

  );

};
export default Discussions;
